// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyCSBear7uYIW7-T4OvZz6VCcz61TSH_Lkw",
    authDomain: "uzhavar-d3688.firebaseapp.com",
    projectId: "uzhavar-d3688",
    storageBucket: "uzhavar-d3688.appspot.com",
    messagingSenderId: "653478586242",
    appId: "1:653478586242:android:08b61675ed99828412919b"
  },
  DHARSTEC_URL: "https://uzhavarapp.dharstec.com/",
  // DHARSTEC_URL: "http://localhost:8011/",
  GOVT_URL: "https://govtuzhavar.dharstec.com/",

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
